import { useMemo } from 'react';

import mapValues from 'lodash/mapValues';

import type { TranslationName } from './useCopyI18nKeys';
import { useCopyI18nKeys } from './useCopyI18nKeys';

type Result = ModelHookResult<Record<TranslationName, string>>;

export function usePageCopy(): Result {
	const {
		data: { keys },
		actions: { translateKey },
	} = useCopyI18nKeys();

	const labels = useMemo(() => {
		return mapValues(
			keys,
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			(i18nKey, name) => translateKey(name as TranslationName, i18nKey),
		);
	}, [keys, translateKey]);

	return {
		data: labels,
	};
}
